import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '2rem' }}>
    <h2 style={{ fontSize: '1.2rem', fontWeight: '700', color: '#1a365d', marginBottom: '0.75rem', borderBottom: '2px solid #bee3f8', paddingBottom: '0.4rem' }}>{title}</h2>
    <div style={{ color: '#4a5568', lineHeight: '1.8', fontSize: '0.97rem' }}>{children}</div>
  </div>
);

const li = { marginBottom: '0.4rem' };

const PrivacyPolicyUz = () => (
  <>
    <div style={{ marginBottom: '2rem' }}>
      <a href="/" style={{ color: '#3182ce', fontSize: '0.9rem', textDecoration: 'none' }}>← Бош саҳифа</a>
      <h1 style={{ fontSize: '1.8rem', fontWeight: '800', color: '#1a365d', marginTop: '1rem', marginBottom: '0.5rem' }}>Маҳфийлик сиёсати</h1>
      <p style={{ color: '#718096', fontSize: '0.9rem' }}>Охирги янгиланган: 17 апрел 2025 йил</p>
    </div>
    <p style={{ color: '#4a5568', lineHeight: '1.8', marginBottom: '2rem' }}>
      Ушбу Маҳфийлик сиёсати <strong>AdvokatTop</strong> (advokattop.uz) платформаси фойдаланувчиларининг шахсий маълумотлари қандай тўпланиши, сақланиши, қўлланилиши ва ҳимоя қилиниши тўғрисида тушунтиради.
    </p>
    <Section title="1. Тўпланадиган маълумотлар">
      <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
        <li style={li}><strong>Рўйхатдан ўтишда:</strong> исм-фамилия, электрон почта манзили, телефон рақами, шаҳар/туман.</li>
        <li style={li}><strong>Адвокатлар учун:</strong> гувоҳнома рақами, гувоҳнома берилган сана, амалиёт соҳалари, биография.</li>
        <li style={li}><strong>Мижозлар учун:</strong> юридик савол матни, тўлов маълумотлари.</li>
        <li style={li}><strong>Техник маълумотлар:</strong> IP-манзил, браузер тури (Google Analytics).</li>
      </ul>
    </Section>
    <Section title="2. Маълумотлар қандай мақсадда ишлатилади">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Ҳисобни яратиш ва аутентификация;</li>
        <li style={li}>Мижозларни тегишли адвокатлар билан боғлаш;</li>
        <li style={li}>Юридик маслаҳат сўровларини қабул қилиш ва жавоблаш;</li>
        <li style={li}>Тўловларни амалга ошириш ва тасдиқлаш;</li>
        <li style={li}>Хизмат сифатини яхшилаш мақсадида статистик таҳлил;</li>
        <li style={li}>Хавфсизликни таъминлаш.</li>
      </ul>
    </Section>
    <Section title="3. Маълумотларни учинчи шахсларга ошкор қилиш">
      <p style={{ marginBottom: '0.75rem' }}>Маълумотлар фақат қуйидаги ҳолатларда учинчи шахсларга узатилади:</p>
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}><strong>Тўлов тизими:</strong> тўловни амалга ошириш учун зарур маълумотлар.</li>
        <li style={li}><strong>Адвокатлар:</strong> мижоз сўрови жўнатилганда.</li>
        <li style={li}><strong>Қонун талаблари:</strong> суд қарори ёки давлат органлари талабига биноан.</li>
      </ul>
    </Section>
    <Section title="4. Маълумотларни сақлаш муддати">
      <p>Ҳисоб фаол бўлган даврда барча шахсий маълумотлар сақланади. Ҳисоб ўчирилганида маълумотлар 30 кун ичида тизимдан батамом ўчирилади.</p>
    </Section>
    <Section title="5. Маълумотлар хавфсизлиги">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Барча маълумотлар HTTPS (SSL/TLS) орқали шифрланган;</li>
        <li style={li}>Пароллар bcrypt алгоритми ёрдамида хешланади;</li>
        <li style={li}>Маълумотлар базаси ташқи тармоқдан изоляция қилинган;</li>
        <li style={li}>JWT токенлари вақт чеклови билан амал қилади.</li>
      </ul>
    </Section>
    <Section title="6. Cookies ва аналитика">
      <p>Платформа Google Analytics ишлатади. Браузерингизда cookie-ларни ўчириш орқали аналитикани рад этишингиз мумкин.</p>
    </Section>
    <Section title="7. Фойдаланувчи ҳуқуқлари">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Ўзингиз ҳақингиздаги маълумотларни кўриш ва тузатиш;</li>
        <li style={li}>Маълумотларни ўчириш талаби билан мурожаат қилиш;</li>
        <li style={li}>Маркетинг хабарларидан воз кечиш.</li>
      </ul>
      <p>Ҳуқуқларингизни амалга ошириш учун: <strong>alis.ergashev@gmail.com</strong></p>
    </Section>
    <Section title="8. Болалар маҳфийлиги">
      <p>Платформа 18 ёшга тўлмаган шахслар учун мўлжалланмаган.</p>
    </Section>
    <Section title="9. Боғланиш">
      <p><strong>Email:</strong> alis.ergashev@gmail.com<br /><strong>Сайт:</strong> advokattop.uz</p>
    </Section>
  </>
);

const PrivacyPolicyRu = () => (
  <>
    <div style={{ marginBottom: '2rem' }}>
      <a href="/" style={{ color: '#3182ce', fontSize: '0.9rem', textDecoration: 'none' }}>← Главная</a>
      <h1 style={{ fontSize: '1.8rem', fontWeight: '800', color: '#1a365d', marginTop: '1rem', marginBottom: '0.5rem' }}>Политика конфиденциальности</h1>
      <p style={{ color: '#718096', fontSize: '0.9rem' }}>Последнее обновление: 17 апреля 2025 г.</p>
    </div>
    <p style={{ color: '#4a5568', lineHeight: '1.8', marginBottom: '2rem' }}>
      Настоящая Политика конфиденциальности разъясняет, как платформа <strong>AdvokatTop</strong> (advokattop.uz) собирает, хранит, использует и защищает персональные данные пользователей. Используя платформу, вы соглашаетесь с условиями настоящей политики.
    </p>
    <Section title="1. Собираемые данные">
      <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
        <li style={li}><strong>При регистрации:</strong> имя, адрес электронной почты, номер телефона, город/район.</li>
        <li style={li}><strong>Для адвокатов:</strong> номер лицензии, дата её выдачи, области практики, биография.</li>
        <li style={li}><strong>Для клиентов:</strong> текст юридического вопроса, платёжные данные.</li>
        <li style={li}><strong>Технические данные:</strong> IP-адрес, тип браузера (Google Analytics).</li>
      </ul>
    </Section>
    <Section title="2. Цели использования данных">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Создание аккаунта и аутентификация;</li>
        <li style={li}>Связь клиентов с подходящими адвокатами;</li>
        <li style={li}>Приём и обработка запросов на юридическую консультацию;</li>
        <li style={li}>Проведение и подтверждение платежей;</li>
        <li style={li}>Статистический анализ в целях улучшения качества сервиса;</li>
        <li style={li}>Обеспечение безопасности и защита от злоупотреблений.</li>
      </ul>
    </Section>
    <Section title="3. Передача данных третьим лицам">
      <p style={{ marginBottom: '0.75rem' }}>Мы не продаём и не сдаём в аренду ваши персональные данные. Данные передаются третьим лицам только в следующих случаях:</p>
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}><strong>Платёжная система:</strong> данные, необходимые для проведения платежа, передаются провайдеру.</li>
        <li style={li}><strong>Адвокаты:</strong> при отправке запроса адвокат видит текст запроса и имя клиента.</li>
        <li style={li}><strong>Требования законодательства:</strong> по решению суда или запросу государственных органов.</li>
      </ul>
    </Section>
    <Section title="4. Срок хранения данных">
      <p>Все персональные данные хранятся в течение срока действия аккаунта. После удаления аккаунта данные полностью удаляются из системы в течение 30 дней.</p>
    </Section>
    <Section title="5. Безопасность данных">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Все данные передаются в зашифрованном виде по HTTPS (SSL/TLS);</li>
        <li style={li}>Пароли хешируются с помощью алгоритма bcrypt;</li>
        <li style={li}>База данных размещена на изолированном VPS-сервере;</li>
        <li style={li}>JWT-токены имеют ограниченный срок действия.</li>
      </ul>
    </Section>
    <Section title="6. Файлы cookie и аналитика">
      <p>Платформа использует Google Analytics для сбора анонимизированной статистики. Вы можете отказаться от аналитики, отключив файлы cookie в браузере.</p>
    </Section>
    <Section title="7. Права пользователей">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Просмотр и исправление своих данных;</li>
        <li style={li}>Запрос на удаление данных;</li>
        <li style={li}>Отказ от маркетинговых сообщений.</li>
      </ul>
      <p>Для реализации своих прав: <strong>alis.ergashev@gmail.com</strong></p>
    </Section>
    <Section title="8. Конфиденциальность детей">
      <p>Платформа не предназначена для лиц младше 18 лет. Мы намеренно не собираем данные пользователей младше 18 лет.</p>
    </Section>
    <Section title="9. Контакты">
      <p><strong>Email:</strong> alis.ergashev@gmail.com<br /><strong>Сайт:</strong> advokattop.uz</p>
    </Section>
  </>
);

const PrivacyPolicy = () => {
  const { language } = useLanguage();
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7fafc', padding: '2rem 1rem' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '2.5rem' }}>
        {language === 'ru' ? <PrivacyPolicyRu /> : <PrivacyPolicyUz />}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
